import {
  GET_ALL_CITY
} from 'src/store/mutation-types'
export default {
  [GET_ALL_CITY] (state, cities) {
    state.cities = cities
  }
}



// WEBPACK FOOTER //
// ./src/components/city/store/mutations.js